import type {
  SelectButtonPassThroughOptions,
  SelectButtonPassThroughMethodOptions
} from "primevue/selectbutton";

export const selectbutton: SelectButtonPassThroughOptions = {
  root: ({ props }) => ({
    class: [
      {
        "opacity-80 select-none pointer-events-none": props.disabled
      }
    ]
  }),
  pcToggleButton: ({
    context,
    props
  }: SelectButtonPassThroughMethodOptions) => ({
    class: [
      "relative",
      // Font
      "leading-none",

      // Flex Alignment
      "inline-flex items-center align-bottom text-center",

      // Spacing
      "px-4 py-3",

      // Shape
      "border border-r-0",
      "first:rounded-l-md first:rounded-tr-none first:rounded-br-none",
      "last:border-r last:rounded-tl-none last:rounded-bl-none last:rounded-r-md",

      // Color
      {
        "bg-white text-[#9291A5] border-[#F0F0F1]":
          !context?.active && !props?.invalid,
        "bg-[#F9564F] border-[#F9564F] text-white font-semibold":
          context?.active
      },
      // Invalid State
      { "!border-red-500": props?.invalid },

      // States
      "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-contrast-bitter-sweet/50 focus:z-10",
      {
        "hover:bg-system-light-grey": !context?.active && !props?.invalid,
        "hover:bg-contrast-peach/40": context?.active
      },
      {
        "opacity-60 select-none pointer-events-none cursor-default":
          context?.disabled
      },
      // Transition
      "transition duration-200",

      // Misc
      "cursor-pointer select-none overflow-hidden"
    ]
  })
};
